import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import PhotoGallery from './components/PhotoGallery';
import Reviews from './components/Reviews';
import Info from './components/Info';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import CustomerLogin from './components/CustomerLogin';
import CustomerPortal from './components/CustomerPortal';
import { Toaster } from './components/ui/sonner';
import './App.css';

function HomePage() {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <PhotoGallery />
      <Gallery />
      <Reviews />
      <Info />
      <Booking />
      <Contact />
      <Footer />
    </>
  );
}

function BookingPage() {
  const hasScrolledRef = React.useRef(false);
  
  useEffect(() => {
    // Scroll to booking section only once on initial mount
    if (!hasScrolledRef.current) {
      const timer = setTimeout(() => {
        const element = document.getElementById('booking');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          hasScrolledRef.current = true;
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, []);

  return <HomePage />;
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/booking" element={<BookingPage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/customer-login" element={<CustomerLogin />} />
        <Route path="/customer-portal" element={<CustomerPortal />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
